// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduleModificationComponent {
  background-color: #f3f4f6;
  height: 100vh;
  padding: 0 42px 60px 42px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.scheduleModificationComponent .container {
  width: 80%;
  margin: auto;
}
.scheduleModificationComponent .container .breadCrumb {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.scheduleModificationComponent .container .breadCrumb .mainScreen,
.scheduleModificationComponent .container .breadCrumb .secondScreen {
  display: inline-block;
  margin-right: 10px;
}
.scheduleModificationComponent .container .breadCrumb .secondScreen {
  margin-left: 10px;
}
.scheduleModificationComponent .container .nameContainer {
  display: flex;
  flex-direction: row;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  margin-top: 10px;
}
.scheduleModificationComponent .container .nameContainer .image {
  background: #c1c1c1;
  border: 1px solid #c1c1c1;
  color: white;
  height: 60px;
  width: 60px;
  border-radius: 30px;
  padding-top: 4px;
  padding-left: 6px;
  text-align: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  display: flex;
  align-items: center;
}
.scheduleModificationComponent .container .nameContainer .nameText {
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  position: relative;
  top: 10px;
  left: 10px;
}
.scheduleModificationComponent .container .cardContainer {
  margin: 24px 32px;
  margin-left: 10px;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
}
.scheduleModificationComponent .container .cardContainer .leftContainer {
  padding: 32px;
  width: 70%;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings {
  display: flex;
  flex-direction: row;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels {
  width: 22%;
  min-width: 148px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .labelRow {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  position: relative;
  top: 20px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .labelRow .labelText {
  position: relative;
  left: 5px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .labelRow .icon {
  position: relative;
  bottom: 2px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .second {
  margin-top: 90px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .third {
  margin-top: 56px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .fourth {
  margin-top: 75px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .labels .fifth {
  margin-top: 48px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls {
  width: 78%;
  min-width: 550px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .dateInputWrapper {
  display: flex;
  flex-direction: row;
  width: 563px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .dateInputWrapper .secondWrapper {
  position: relative;
  top: 1px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .dropDownWrapper {
  width: 550px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .timePickerRow {
  display: flex;
  flex-direction: row;
  width: 555px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .timePickerRow .timer {
  padding-top: 15px;
  width: 50%;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .timePickerRow .dropDown {
  width: 49%;
  position: relative;
  bottom: 20px;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .settings .controls .rightDivider {
  height: 2px;
  position: relative;
  top: 40px;
  width: 550px;
  background-color: #f2f2f2;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .divider {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  text-align: left;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .divider .left {
  display: flex;
  flex-direction: row;
}
.scheduleModificationComponent .container .cardContainer .leftContainer .divider .left .icon {
  margin-right: 8px;
  position: relative;
  bottom: 2px;
}
.scheduleModificationComponent .container .cardContainer .rightContainer {
  width: 30%;
  border-left: 1px solid #f2f2f2;
  padding: 32px;
}
.scheduleModificationComponent .container .cardContainer .rightContainer .title {
  margin-top: 20px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.scheduleModificationComponent .container .cardContainer .rightContainer .description {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.scheduleModificationComponent .container .cardContainer .rightContainer .first {
  margin-top: 30px;
}
.scheduleModificationComponent .container .cardContainer .rightContainer .second {
  margin-top: 70px;
}
.scheduleModificationComponent .container .cardContainer .rightContainer .third {
  margin-top: 202px;
}
.scheduleModificationComponent .container .cardContainer .hourContainer {
  margin-top: 31px;
  height: 68px;
  width: 82%;
  background: #f0f8f6;
  border: 1px solid #d6e7e4;
  border-radius: 8px;
  padding: 22px 34px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  line-height: 24px;
  display: flex;
  flex-direction: row;
  align-content: space-between;
}
.scheduleModificationComponent .container .cardContainer .hourContainer .leftContainerText {
  color: #075453;
  font-weight: 700;
  font-size: 18px;
}
.scheduleModificationComponent .container .cardContainer .hourContainer .rightContainerText {
  margin-left: auto;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #49ae9e;
  display: flex;
  flex-direction: row;
}
.scheduleModificationComponent .container .cardContainer .hourContainer .rightContainerText .tick {
  height: 30px;
  width: 15px;
  position: relative;
  bottom: 13px;
  right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/screens/scheduleModification/ScheduleModification.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,yBAAA;EAEA,iCAAA;EACA,kBAAA;AAAJ;AACI;EACI,UAAA;EACA,YAAA;AACR;AACQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACZ;AACY;;EAEI,qBAAA;EACA,kBAAA;AAChB;AACY;EACI,iBAAA;AAChB;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AADZ;AAGY;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AADhB;AAIY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAFhB;AAMQ;EACI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAJZ;AAOY;EACI,aAAA;EACA,UAAA;AALhB;AAMgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAJpB;AAOgB;EACI,aAAA;EACA,mBAAA;AALpB;AAMoB;EACI,UAAA;EACA,gBAAA;AAJxB;AAMwB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,SAAA;AAL5B;AAO4B;EACI,kBAAA;EACA,SAAA;AALhC;AAO4B;EACI,kBAAA;EACA,WAAA;AALhC;AAQwB;EACI,gBAAA;AAN5B;AAQwB;EACI,gBAAA;AAN5B;AAQwB;EACI,gBAAA;AAN5B;AAQwB;EACI,gBAAA;AAN5B;AAUoB;EACI,UAAA;EACA,gBAAA;AARxB;AAUwB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAR5B;AAS4B;EACI,kBAAA;EACA,QAAA;AAPhC;AAUwB;EACI,YAAA;AAR5B;AAWwB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAT5B;AAU4B;EACI,iBAAA;EACA,UAAA;AARhC;AAU4B;EACI,UAAA;EACA,kBAAA;EACA,YAAA;AARhC;AAYwB;EACI,WAAA;EACA,kBAAA;EAEA,SAAA;EACA,YAAA;EACA,yBAAA;AAX5B;AAgBgB;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAdpB;AAeoB;EACI,aAAA;EACA,mBAAA;AAbxB;AAewB;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AAb5B;AAkBY;EACI,UAAA;EACA,8BAAA;EACA,aAAA;AAhBhB;AAiBgB;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfpB;AAiBgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfpB;AAiBgB;EACI,gBAAA;AAfpB;AAiBgB;EACI,gBAAA;AAfpB;AAiBgB;EACI,iBAAA;AAfpB;AAmBY;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;AAjBhB;AAmBgB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAjBpB;AAmBgB;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAjBpB;AAkBoB;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAhBxB","sourcesContent":[".scheduleModificationComponent {\n    background-color: #f3f4f6;\n    height:  100vh ;\n    padding: 0 42px 60px 42px;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    .container {\n        width: 80%;\n        margin: auto;\n\n        .breadCrumb {\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n\n            .mainScreen,\n            .secondScreen {\n                display: inline-block;\n                margin-right: 10px;\n            }\n            .secondScreen {\n                margin-left: 10px;\n            }\n        }\n\n        .nameContainer {\n            display: flex;\n            flex-direction: row;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            margin-top: 10px;\n\n            .image {\n                background: #c1c1c1;\n                border: 1px solid #c1c1c1;\n                color: white;\n                height: 60px;\n                width: 60px;\n                border-radius: 30px;\n                padding-top: 4px;\n                padding-left: 6px;\n                text-align: center;\n                font-weight: 500;\n                font-size: 24px;\n                line-height: 34px;\n                display: flex;\n                align-items: center;\n            }\n\n            .nameText {\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #333333;\n                position: relative;\n                top: 10px;\n                left: 10px;\n            }\n        }\n\n        .cardContainer {\n            margin: 24px 32px;\n            margin-left: 10px;\n            background: #ffffff;\n            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n            border-radius: 8px;\n            display: flex;\n            flex-direction: row;\n            \n\n            .leftContainer {\n                padding: 32px;\n                width: 70%;\n                .title {\n                    font-weight: 700;\n                    font-size: 20px;\n                    line-height: 30px;\n                    color: #333333;\n                }\n\n                .settings {\n                    display: flex;\n                    flex-direction: row;\n                    .labels {\n                        width: 22%;\n                        min-width: 148px;\n\n                        .labelRow {\n                            margin-top: 5px;\n                            display: flex;\n                            flex-direction: row;\n\n                            position: relative;\n                            top: 20px;\n\n                            .labelText {\n                                position: relative;\n                                left: 5px;\n                            }\n                            .icon {\n                                position: relative;\n                                bottom: 2px;\n                            }\n                        }\n                        .second {\n                            margin-top: 90px;\n                        }\n                        .third {\n                            margin-top: 56px;\n                        }\n                        .fourth {\n                            margin-top: 75px;\n                        }\n                        .fifth {\n                            margin-top: 48px;\n                        }\n                    }\n\n                    .controls {\n                        width: 78%;\n                        min-width: 550px;\n\n                        .dateInputWrapper {\n                            display: flex;\n                            flex-direction: row;\n                            width: 563px;\n                            .secondWrapper{\n                                position: relative;\n                                top:1px; \n                            }\n                        }\n                        .dropDownWrapper {\n                            width: 550px; \n                        }\n\n                        .timePickerRow {\n                            display: flex;\n                            flex-direction: row;\n                            width: 555px;\n                            .timer {\n                                padding-top: 15px;\n                                width: 50%;\n                            }\n                            .dropDown {\n                                width: 49%;\n                                position: relative;\n                                bottom: 20px;\n                            }\n                        }\n\n                        .rightDivider {\n                            height: 2px;\n                            position: relative;\n\n                            top: 40px;\n                            width: 550px;\n                            background-color: #f2f2f2;\n                        }\n                    }\n                }\n\n                .divider {\n                    margin-top: 10px;\n                    display: flex;\n                    flex-direction: row;\n                    text-align: left;\n                    .left {\n                        display: flex;\n                        flex-direction: row;\n\n                        .icon {\n                            margin-right: 8px;\n                            position: relative;\n                            bottom: 2px;\n                        }\n                    }\n                }\n            }\n            .rightContainer {\n                width: 30%;\n                border-left: 1px solid #f2f2f2;\n                padding: 32px;\n                .title {\n                    margin-top: 20px;\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n                .description {\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: #999999;\n                }\n                .first {\n                    margin-top: 30px;\n                }\n                .second {\n                    margin-top: 70px;\n                }\n                .third {\n                    margin-top: 202px;\n                }\n            }\n\n            .hourContainer {\n                margin-top: 31px;\n                height: 68px;\n                width: 82%;\n                background: #f0f8f6;\n                border: 1px solid #d6e7e4;\n                border-radius: 8px;\n                padding: 22px 34px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                line-height: 24px;\n                display: flex;\n                flex-direction: row;\n                align-content: space-between;\n\n                .leftContainerText {\n                    color: #075453;\n                    font-weight: 700;\n                    font-size: 18px;\n                }\n                .rightContainerText {\n                    margin-left: auto;\n                    font-weight: 500;\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: #49ae9e;\n                    display: flex;\n                    flex-direction: row;\n                    .tick{\n                        height:30px;\n                        width:15px;\n                        position: relative;\n                        bottom:13px;\n                        right:5px;\n\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
